import { FC, useContext } from 'react';
import { context as StateContext } from '../context/state';
import { context as DependencyContext } from '../context/dependency';
import Page from '../page/CustomReportPage';

type Props = { className?: string };

const CustomReportPage: FC<Props> = ({ className }) => {
  const state = useContext(StateContext);
  const dependency = useContext(DependencyContext);

  return (
    <Page
      organization={state.lastAccessedOrganization.item}
      chartGroup={state.customReport.data?.groups[state.selectedChartGroup.data]}
      customReportChartSetting={state.customReportChartSetting.period}
      customReportLoading={state.customReport.fetching > 0 || state.lastAccessedOrganization.fetching > 0}
      onMount={() => {
        dependency.customReportUsecase.prepareCustomReport();
      }}
      onUnmount={() => {
        dependency.customReportUsecase.dispose();
      }}
      className={className}
    />
  );
};

export default CustomReportPage;
